const faqs = [
  {
    q: '酷漫屋的下拉式阅读和传统翻页有什么区别？',
    a: '酷漫屋的下拉式阅读专为竖屏条漫量身打造。传统翻页漫画需要点击按钮或左右滑动切换画面，而酷漫屋的下拉式阅读让你只需像刷社交媒体一样向下滑动，漫画内容就会连续不断展开，阅读节奏自然顺畅。所有漫画都经过竖屏自适应处理，画面自动适配你的手机或平板屏幕宽度，不需要放大缩小，阅读体验更加沉浸舒适。',
  },
  {
    q: '酷漫屋上的漫画真的是全部免费吗？',
    a: '是的，酷漫屋坚持全站免费阅读原则。平台上所有收录的漫画作品——无论是日漫、韩漫还是国漫、连载还是完结——都不收取任何阅读费用。你无需充值会员、无需购买章节、无需消耗阅读券，打开就能看。我们通过广告和合作来维持平台运营，确保每位漫画爱好者都能无门槛享受条漫阅读的乐趣。',
  },
  {
    q: '酷漫屋支持哪些设备阅读？',
    a: '酷漫屋全面支持多种设备：网页版通过浏览器直接访问即可阅读，无需安装任何插件；移动端APP已上架iOS App Store和各大Android应用商店，专为竖屏条漫优化；平板设备同样完美适配。无论你使用什么设备，都能获得一致流畅的下拉式阅读体验。阅读进度支持云端同步，在不同设备切换也不会丢失记录。',
  },
  {
    q: '如何找到我想看的漫画？更新频率如何？',
    a: '你可以通过首页的热门排行、主题索引、精选推荐等模块快速发现热门漫画，也可以通过话题标签按题材类型筛选感兴趣的内容。酷漫屋每日更新频次稳定在300话以上，热门连载作品通常保持每周2-3话的更新节奏。建议关注首页的"更新动态"栏目，可以实时追踪最新上架的漫画内容和章节更新信息。',
  },
  {
    q: '漫画加载慢怎么办？支持离线阅读吗？',
    a: '网页版漫画采用图片懒加载技术，会根据网络状况自动优化加载策略。如果遇到加载慢的情况，建议检查网络连接或尝试切换WiFi。移动端APP支持离线下载功能，你可以提前下载想看的漫画章节，在地铁、飞机等无网络环境下也能正常阅读。离线下载的漫画会保存在手机本地存储中，随时可以删除释放空间。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于酷漫屋的使用方式和常见疑问，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => {
            const isAccent = i === 0 || i === 3;
            return (
              <div
                key={i}
                className={`rounded-lg overflow-hidden ${
                  isAccent
                    ? 'bg-accent-50 border border-accent-200/60'
                    : 'bg-background-50 border border-background-200/70'
                }`}
              >
                <div className="p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2.5 flex items-start gap-2.5">
                    <span className={`flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full text-xs ${
                      isAccent ? 'bg-accent-500 text-background-50' : 'bg-primary-500 text-background-50'
                    }`}>
                      Q
                    </span>
                    {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed pl-7 md:pl-8">{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}